export function accordionServices() {

    var allPanels = $('.panel');
    $('.panel').first().slideDown();
    var allAccordions = $('.accordion-wrapper .wrap');
    var allSubAccordions = $('.sub-accordion .wrap');
    allAccordions.first().addClass('active');

    if ($(window).width() > 767) {
        $('.js-accordion-services .desktop-image').removeClass('active');
        $('.js-accordion-services .desktop-image').first().addClass('active');
    } else {
        $('.js-accordion-services .mobile-image').removeClass('active');
        $('.js-accordion-services .mobile-image').first().addClass('active');
    }

    $('.js-accordion-services .right-gallery').removeClass('active');
    $('.js-accordion-services .right-gallery').first().addClass('active');

    $('.accordion').click(function () {
        $(window).trigger('resize');

        var id = $(this).attr("id");
        if ($(window).width() > 767) {
            $('.js-accordion-services .desktop-image').removeClass('active');
            $('[data-idD =' + id + ']').addClass('active');
        } else {
            $('.js-accordion-services .mobile-image').removeClass('active');
            $('[data-idM =' + id + ']').addClass('active');
        }

        $('.js-accordion-services .right-gallery').removeClass('active');
        $('[data-idD =' + id + ']').addClass('active');

        if (!$(this).parent().hasClass('active')) {
            if (!$(this).closest('.sub-accordion').length) {
                if ($(this).parents(".grid").find(".right-gallery .js-gallery-slider").length) {
                    $(this).parents(".grid").find(".right-gallery .js-gallery-slider").slick('setPosition');
                }
                allAccordions.removeClass("active");
                allAccordions.find('.sub-accordion').slideUp();
            } else {
                if ($(this).parents(".grid").find(".right-gallery .js-gallery-slider").length) {
                    $(this).parents(".grid").find(".right-gallery .js-gallery-slider").slick('setPosition');
                }
                if (!$(this).parent().hasClass('active')) {
                    allSubAccordions.removeClass("active");
                }
            }
            allPanels.slideUp();
            $(this).next().slideDown();
            $(this).parent().addClass('active');
            $(this).parent().find('.sub-accordion').slideDown();
            if ($(this).parents(".grid").find(".right-gallery .js-gallery-slider").length) {
                $(this).parents(".grid").find(".right-gallery .js-gallery-slider").slick('setPosition');
            }

            return false;
        } else {
            if ($(this).parents(".grid").find(".right-gallery .js-gallery-slider").length) {
                $(this).parents(".grid").find(".right-gallery .js-gallery-slider").slick('setPosition');
            }
            $(this).parent().removeClass('active');
            $(this).next().slideUp();
        }

        return false;
    });

    $('.accordion-wrapper').each(function (index, element) {
        if (index === 0) {
            $(this).find('.sub-accordion').slideDown();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion-services.js